import { useMemo } from 'react';
import { useMount } from 'react-use';

import { MedicalRecordNumber } from '@dreryk/egabinet-patient-published-language-api';

import { FormContextValues, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../../translations';

import { StyledMedicalRecordNumberField } from './MedicalRecordNumberField.styled';

type MedicalRecordNumberFormBeanPart = {
   medicalRecordNumber?: string | null;
};
type MedicalRecordNumberFieldProps = Pick<
   FormContextValues<MedicalRecordNumberFormBeanPart>,
   'register' | 'setValue'
> & { patientMedicalRecordNumber: MedicalRecordNumber | null | undefined };

export const MedicalRecordNumberField = (props: MedicalRecordNumberFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<MedicalRecordNumberFormBeanPart>>(
      () => ({
         required: true,
         maxLength: MedicalRecordNumber.MAX_LENGTH,
         validate: (value) =>
            MedicalRecordNumber.isValueValid(value as string)
               ? undefined
               : patientTranslationKeys.invalidMedicalRecordNumber,
      }),
      []
   );

   useMount(() => {
      if (props.patientMedicalRecordNumber) {
         props.setValue('medicalRecordNumber', props.patientMedicalRecordNumber.asString());
      }
   });

   return (
      <StyledMedicalRecordNumberField>
         <TextInput
            controller={props.register('medicalRecordNumber', validationRules)}
            label={patientTranslationKeys.personalIdentifier}
            testId={'medicalRecordNumber'}
            defaultValue={null}
         />
      </StyledMedicalRecordNumberField>
   );
};
